import {z as zod} from "zod";

export type Filter = {
    column: string;
    operator: string;
    value: unknown;
};

export type ComplexFilter = {
    filters: Array<Filter | ComplexFilter>;
    logic: "AND" | "OR";
};

const filterValidator = zod.strictObject({column: zod.string(), operator: zod.string(), value: zod.unknown()});

export const complexFilterValidator: zod.ZodType<ComplexFilter> = zod.lazy(() =>
    zod.strictObject({filters: zod.array(zod.union([complexFilterValidator, filterValidator])), logic: zod.enum(["AND", "OR"])}),
);
